import React, { ReactElement, useContext, createRef, useEffect,useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    Drawer, Form, notification, Select, Space, Button, Input,
} from 'antd'
import type { FormInstance } from 'antd/es/form'
import type { IAppState } from '@/store/reducers'
import { SmileOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { DrawerShowContext } from '@/pages/table2Mana/table2EditApplyList'
import { getWorkgroup } from '@/services/table.service'
import { getTechClassification } from '@/store/actions/tableEdit.action'

function ChangeApprovalSearchPop (): ReactElement {
    const dispatch = useDispatch()
    const [initFlg, setInitFlg] = useState(true)
    const { t, i18n } = useTranslation()
    const { showSearchPop, setShowSearchPop, classArr, getList } = useContext(DrawerShowContext)
    const [workClassArr, setWorkClassArr] = useState<any []>([])
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const authInfo = useSelector((state: IAppState) => state.auth.authInfo)
    const formRef = createRef<FormInstance>()
    const { Option } = Select
    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    }
    const tailLayout = {
        wrapperCol: { offset: 8, span: 10 },
    }
    const onClose = () => {
        setShowSearchPop(false)
    }
    const onFinish = (formData: any) => {
        const values = {
            ...formData,
        }
        console.log('values: ', values)
        getList(null, values)
        onClose()
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any}) => {
        if (errorFields.length) {
            const args = {
                message: t('FinishFailed'),
                description: '',
                icon: <SmileOutlined style={{ color: '#e1931e' }} />,
                duration: 3,
            }
            notification.open(args)
        }
    }
    const onReset = () => {
        formRef.current?.resetFields()
    }

    useEffect(() => {
        if (!workgroupList.length) {
            // 获取 workgroupList
            dispatch(getWorkgroup())
        }
    }, [])

    useEffect(() => {
        if (initFlg) return
        setWorkClassArr(classArr)
    }, [classArr])

    const changeWorkGroup = (e:any)=>{
        console.log(e)
        setInitFlg(false)
        dispatch(getTechClassification({
            pageNo: 1,
            pageSize: 100,
            workGroupId: e
        }))
    }

    return (
        <Drawer title={t('search') + (i18n.language !== 'zh' ? ' ' : '') + t('condition')} placement="right"
            width={600}
            onClose={onClose} visible={showSearchPop}
        >
            <Form {...layout} ref={formRef}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <Form.Item name="workGroupId" label={<span className='label'>{t('Work Group')}</span>}>
                    <Select placeholder={t('Work Group Placeholder')} style={{ width: '100%' }} allowClear onChange={changeWorkGroup}>
                        {
                            workgroupList.map(item => {
                                return <Option key={item.id} value={item.id}>{item.groupName}</Option>
                            })
                        }
                    </Select>
                </Form.Item>
                <Form.Item name="techClassId" label={<span className='label'>{t('Classification')}</span>}>
                    <Select placeholder={t('Classification Placeholder')} style={{ width: '100%' }} allowClear>
                        {
                            workClassArr.map(item => (
                                <Option value={item.classId} key={item.classId}
                                    title={item.classificationName}
                                >{item.classificationName}</Option>
                            ))
                        }
                    </Select>
                </Form.Item>
                <Form.Item name="techPtn" label={<span className='label'>{t('PTN')}</span>}>
                    <Input placeholder={t('PTN Placeholder')} />
                </Form.Item>
                <Form.Item name="techName" label={<span className='label'>{t('Technology Name')}</span>}>
                    <Input placeholder={t('Tech Name Placeholder')} />
                </Form.Item>
                {authInfo && Reflect.has(authInfo, 'auditChange') && (<>
                    <Form.Item name="creator" label={<span className='label'>{t('creator')}</span>}>
                        <Input placeholder={t('Please Enter') + (i18n.language !== 'zh' ? ' ' : '') + t('creator')} />
                    </Form.Item>
                    <Form.Item name="auditor" label={<span className='label'>{t('auditor')}</span>}>
                        <Input placeholder={t('Please Enter') + (i18n.language !== 'zh' ? ' ' : '') + t('auditor')} />
                    </Form.Item>
                </>)}
                <Form.Item name="auditStatus" label={<span className='label'>{t('auditStatus')}</span>}>
                    <Select allowClear placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('auditStatus')} >
                        <Option value={1}>{t('auditWait')}</Option>
                        <Option value={2}>{t('auditPass')}</Option>
                        <Option value={3}>{t('auditUnPass')}</Option>
                    </Select>
                </Form.Item>
                <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                    <Space size={20}>
                        <Button type="primary" htmlType="submit">
                            {t('search')}
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            {t('reset')}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Drawer>
    )
}

export default ChangeApprovalSearchPop
